import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "./actionTypes";
import { saveYoutubePlan, fetchUserJobs } from "./sermonStudiesAPI";
import {
  saveYoutubePlanSuccess,
  saveYoutubePlanFailure,
  fetchUserJobsSuccess,
  fetchUserJobsFailure
} from "./sermonStudiesAction";

function* saveYoutubePlanSaga(action) {
  try {
    const response = yield call(saveYoutubePlan, action.payload);
    yield put(saveYoutubePlanSuccess(response));
    if (action.callback) {
      action.callback(response);
    }
  } catch (error) {
    yield put(saveYoutubePlanFailure(error));
    if (action.callback) {
      action.callback({ type: 0, message: error.message });
    }
  }
}

function* fetchUserJobsSaga(action) {
  try {
    const response = yield call(fetchUserJobs, action.payload);
    yield put(fetchUserJobsSuccess(response));
    if (action.callback) {
      action.callback(response);
    }
  } catch (error) {
    yield put(fetchUserJobsFailure(error));
    if (action.callback) {
      action.callback({ type: 0, message: error.message });
    }
  }
}

export default function* sermonStudiesWatcherSaga() {
  yield takeLatest(types.SAVE_YOUTUBE_PLAN_REQUEST, saveYoutubePlanSaga);
  yield takeLatest(types.FETCH_USER_JOBS_REQUEST, fetchUserJobsSaga);
}
